export const OPENCLOSE_SIDEMENU = "OPENCLOSE_SIDEMENU";
export const OPEN_FORMMENU = "OPEN_FORMMENU";
export const OPEN_USUARIOS = "OPEN_USUARIOS";

export const UPLOADING_IMAGE = "UPLOADING_IMAGE";

export const LOAD_ACTIVITIES = "LOAD_ACTIVITIES";
export const OPEN_ACTIVITIES = "OPEN_ACTIVITIES";

export const LOAD_USERS = "LOAD_USERS";
export const LOAD_ANALYTICS = "LOAD_ANALYTICS";

export const OPEN_QUESTIONS = "OPEN_QUESTIONS";
export const OPEN_TOPQUESTIONS = "OPEN_TOPQUESTIONS";
export const OPEN_ANALYTICS = "OPEN_ANALYTICS";

export const LOAD_QUESTIONS = "LOAD_QUESTIONS";
export const LOAD_TOPQUESTIONS = "LOAD_TOPQUESTIONS";

export const LOAD_LEVELS = "LOAD_LEVELS";
export const LOAD_LEVELCATEGORIES = "LOAD_LEVELCATEGORIES";


export const LOAD_FAVOURITES = "LOAD_FAVOURITES";
export const OPEN_FAVOURITES = "OPEN_FAVOURITES";

export const LOAD_PROMOTIONS = "LOAD_PROMOTIONS";

export const OPEN_PROMOTIONS = "OPEN_PROMOTIONS";

export const LOAD_PRINCIPAL = "LOAD_PRINCIPAL";

export const OPEN_PRINCIPAL = "OPEN_PRINCIPAL";
